import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/home";
import { ClaycoHeader } from "clayco-carbon10/dist/index.umd";
import { Content, HeaderMenuItem } from "carbon-components-react";
import { useNavigate, useLocation } from "react-router-dom";
import Contact from "./pages/contact";
import Employee from "./pages/employee/employee";
import Dependents from "./pages/dependents/dependents";
import Medical from "./pages/medical/medical";
import Dental from "./pages/dental/dental";
import Vision from "./pages/vision/vision";
import Disability from "./pages/disability/disability";
import FSA from "./pages/fsa/fsa";
import Review from "./pages/review/review";
import { useEffect } from "react";
import LifeInsurance from "./pages/lifeInsurance/lifeInsurance";
import { useDispatch, useSelector } from "react-redux";
import useMsalApi from "./components/use-msal-api";
import { updateEnrollments } from "./redux/actions/enrollments-actions";
import Admin from "./pages/admin/admin";
import { useMsal } from "@azure/msal-react";
import { setAdmin, setAdminSessions } from "./redux/actions/admin-actions";
import OpenEnrollmentList from "./pages/admin/open-enrollment-list";
import PendingSubmissions from "./pages/admin/pending-submissions";
import BeneficiariesPage from "./pages/beneficiaries/beneficiaries-page";
import Completed from "./pages/completed/completed";
import BeneficiariesCompleted from "./pages/completed/beneficiaries-updated";
import { EnrollmentType } from "./components/enums/enrollment-type";
import CurrentElections from "./pages/current-elections/current-elections";
import Submission from "./pages/submission/submission";
import AlreadyEnrolled from "./pages/already-enrolled/already-enrolled.jsx";
import Saved from "./pages/saved/saved";
import ApprovedSubmissions from "./pages/admin/approved-submissions";
import VideoPlayer from "./pages/video-player/video-player.jsx";
// import Footer from "./components/footer";
// import "./Footer.css";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [callApi] = useMsalApi();
  const { accounts } = useMsal();
  const admin = useSelector((s) => s.admin);

  useEffect(() => {

    const getAdminActivity = async () => {
      console.log("Location", location);
      const results = await callApi("Enrollments/ActiveCreatedByMe", "GET");
      if (!results.error) dispatch(setAdminSessions(results));
      if (results.length === 1) {
        // if(location.pathname !== "/Admin")
        //   getBenefits(results[0].createdOnBehalfOf);
      } else {
        //navigate("/Admin");
      }
    };

    let admin = { isAdmin: false };
    if (accounts[0].idTokenClaims?.roles?.includes("BenefitsAdmin")) {
      admin.isAdmin = true;
      getAdminActivity();
    }
    dispatch(setAdmin(admin));
  }, []);

  return (
    <>
      <div className="page-container">
        <div className="content-wrap">
          <ClaycoHeader
            title="Employee Benefits"
            showAppSwitcher={false}
            headerNavItems={
              admin.isAdmin === true ? (
                <HeaderMenuItem
                  aria-label="Contact Us"
                  onClick={() => {
                    navigate("/Admin");
                  }}
                >
                  Admin
                </HeaderMenuItem>
              ) : null
            }
            panelBody={
              <p className="text-center py-4 px-2">
                This area will provide a unique list of links to other
                applications based on the logged-in user.
              </p>
            }
          />
          <Content>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/Admin" element={<Admin />} />
              <Route
                exact
                path="/Admin/OpenEnrollmentReport"
                element={<OpenEnrollmentList />}
              />
              <Route
                exact
                path="/Admin/PendingSubmissions"
                element={<PendingSubmissions />}
              />
             <Route
                exact
                path="/Admin/ApprovedSubmissions"
                element={<ApprovedSubmissions />}
              />

              <Route exact path="/Contact" element={<Contact />} />
              <Route
                exact
                path="/Employee"
                element={<Employee pageStep={1} />}
              />
              <Route
                exact
                path="/Dependents"
                element={<Dependents pageStep={2} />}
              />
              <Route exact path="/Medical" element={<Medical pageStep={3} />} />
              <Route exact path="/Dental" element={<Dental pageStep={4} />} />
              <Route exact path="/Vision" element={<Vision pageStep={5} />} />
              <Route
                exact
                path="/Disability"
                element={<Disability pageStep={6} />}
              />
              <Route
                exact
                path="/LifeInsurance"
                element={<LifeInsurance pageStep={7} />}
              />
              <Route exact path="/FSA" element={<FSA pageStep={8} />} />
              <Route exact path="/Review" element={<Review pageStep={9} />} />
              <Route
                exact
                path="/Beneficiaries"
                element={<BeneficiariesPage />}
              />
              <Route exact path="/Completed" element={<Completed />} />
              <Route exact path="/BeneficiariesCompleted" element={<BeneficiariesCompleted />} />
              <Route exact path="/Saved" element={<Saved />} />
              <Route exact path="/AlreadyEnrolled" element={<AlreadyEnrolled />} />
              <Route exact path="/Elections" element={<CurrentElections />} />

              <Route path="/Submission" element={<Submission />}>
                <Route path=":enrollmentsId" element={<Submission />} />
              </Route>
              <Route path="/VideoPlayer" element={<VideoPlayer />} />
              <Route path="/VideoPlayer/:videoUrl" element={<VideoPlayer />} />
            </Routes>
          </Content>
        </div>
        {/*   */}
      </div>
    </>
  );
}

export default App;